import type { FC } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { AppViewer } from '../components/AppViewer/AppViewer';
import { GraphicsPanel } from '../components/GraphicsPanel/GraphicsPanel';
import type { TRootState } from '../store/appStateTypes';
import {
  useStyleFromUrl,
  useViewerControlsFromUrl,
  useUnitsFromUrl,
  useShowGraphicsPanelFromUrl,
} from './StyleViewerPage.hooks';

const PageLayout = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

export const StyleViewerPage: FC = () => {
  useStyleFromUrl();
  const { controlsLayout, controlsStyle } = useViewerControlsFromUrl();
  const sceneIsLoading = useSelector((state: TRootState) => state.app.sceneIsLoading);

  const units = useUnitsFromUrl();
  const showGraphicsPanel = useShowGraphicsPanelFromUrl();

  return (
    <PageLayout>
      <AppViewer
        controlsLayout={controlsLayout}
        controlsStyle={controlsStyle}
        showGraphicsPanel={showGraphicsPanel}
      />
      {showGraphicsPanel && <GraphicsPanel disabled={sceneIsLoading} units={units} />}
    </PageLayout>
  );
};
